import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import PrivateRoute from "./components/PrivateRoute";
import UserManagement from "layouts/users";

// @mui icons
import Icon from "@mui/material/Icon";
import VehicleApprovals from "layouts/vehicleApprovals";
import SupportRequests from "layouts/supportRequests";
import TermsConditions from "layouts/termsConditions";
import PrivacyPolicy from "layouts/privacyPolicy";
import FaqManagement from "layouts/faqManagement";
import Inquiries from "layouts/inquiries";
import Reports from "layouts/reports";
import DutyEstimator from "layouts/dutyEstimator";
import CategoriesManagement from "layouts/categories";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "User Management",
    key: "users",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/users",
    component: (
      <PrivateRoute>
        <UserManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/categories",
    component: (
      <PrivateRoute>
        <CategoriesManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Vehicle Approvals",
    key: "vehicle-approvals",
    icon: <Icon fontSize="small">rule</Icon>,
    route: "/vehicle-approvals",
    component: (
      <PrivateRoute>
        <VehicleApprovals />
      </PrivateRoute>
    ),
  },

  {
    type: "collapse",
    name: "Inquiries",
    key: "inquiries",
    icon: <Icon fontSize="small">forum</Icon>,
    route: "/inquiries",
    component: (
      <PrivateRoute>
        <Inquiries />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Listing Reports",
    key: "reports",
    icon: <Icon fontSize="small">flag</Icon>,
    route: "/reports",
    component: (
      <PrivateRoute>
        <Reports />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Duty Estimator",
    key: "duty-estimator",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/duty-estimator",
    component: (
      <PrivateRoute>
        <DutyEstimator />
      </PrivateRoute>
    ),
  },
  {
    type: "hidden",
    name: "Support Requests",
    key: "support-requests",
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: "/support-requests",
    component: (
      <PrivateRoute>
        <SupportRequests />
      </PrivateRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Terms & Conditions",
  //   key: "terms-conditions",
  //   icon: <Icon fontSize="small">gavel</Icon>,
  //   route: "/terms-conditions",
  //   component: (
  //     <PrivateRoute>
  //       <TermsConditions />
  //     </PrivateRoute>
  //   ),
  // },
  // {
  //   type: "collapse",
  //   name: "Privacy Policy",
  //   key: "privacy-policy",
  //   icon: <Icon fontSize="small">policy</Icon>,
  //   route: "/privacy-policy",
  //   component: (
  //     <PrivateRoute>
  //       <PrivacyPolicy />
  //     </PrivateRoute>
  //   ),
  // },
  {
    type: "collapse",
    name: "FAQ Management",
    key: "faq-management",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/faq-management",
    component: (
      <PrivateRoute>
        <FaqManagement />
      </PrivateRoute>
    ),
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
